module.exports = global["_"] = require("-!c:\\jenkins\\workspace\\_classic_ownerportal_development\\Solutions\\op\\Owner.Portal\\node_modules\\expose-loader\\index.js?underscore!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 44
// module chunks = 0